import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { patient } from "../../types";

const patientSliceState: patient.PatientStateType = {
  addPatientDetails: {
    data: null,
    isLoading: false,
    errors: "",
  },
  getPatientList: {
    data: null,
    isLoading: false,
    errors: "",
  },
  deletePatientRecord: {
    isLoading: false,
    errors: "",
    isSuccess: null,
  },
  addPatientPlan: {
    data: null,
    isLoading: false,
    errors: "",
  },
  patientQueryList: {
    data: null,
    isLoading: false,
    errors: "",
  },
  patientSendQuery: {
    data: null,
    isLoading: false,
    errors: "",
  },
};

export const patientSlice = createSlice({
  name: "patient",
  initialState: patientSliceState,
  reducers: {
    // get Patient list
    getPatientListRequest: (
      state: patient.PatientStateType,
      action: PayloadAction<any>
    ) => {
      state.getPatientList.isLoading = true;
      state.getPatientList.errors = "";
      state.getPatientList.data = null;
    },
    getPatientListSuccess: (
      state: patient.PatientStateType,
      action: PayloadAction<any>
    ) => {
      state.getPatientList.isLoading = false;
      state.getPatientList.data = action.payload;
      state.getPatientList.errors = null;
    },
    getPatientListError: (
      state: patient.PatientStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.getPatientList.isLoading = false;
      state.getPatientList.errors = error;
      state.getPatientList.data = null;
    },

    // add Patient details
    addPatientRequest: (
      state: patient.PatientStateType,
      action: PayloadAction<any>
    ) => {
      state.addPatientDetails.isLoading = true;
      state.addPatientDetails.errors = "";
      state.addPatientDetails.data = null;
    },
    addPatientSuccess: (
      state: patient.PatientStateType,
      action: PayloadAction<any>
    ) => {
      state.addPatientDetails.isLoading = false;
      state.addPatientDetails.data = action.payload;
      state.addPatientDetails.errors = null;
    },
    addPatientError: (
      state: patient.PatientStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.addPatientDetails.isLoading = false;
      state.addPatientDetails.errors = error;
      state.addPatientDetails.data = null;
    },

    // delete Patient record
    deletePatientRecordRequest: (
      state: patient.PatientStateType,
      action: PayloadAction<any>
    ) => {
      state.deletePatientRecord.isLoading = true;
      state.deletePatientRecord.errors = "";
      state.deletePatientRecord.isSuccess = null;
    },
    deletePatientRecordSuccess: (
      state: patient.PatientStateType,
      action: PayloadAction<any>
    ) => {
      state.deletePatientRecord.isLoading = false;
      state.deletePatientRecord.isSuccess = true;
      state.deletePatientRecord.errors = null;
    },
    deletePatientRecordError: (
      state: patient.PatientStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.deletePatientRecord.isLoading = false;
      state.deletePatientRecord.errors = error;
    },
    addPatientPlanRequest: (
      state: patient.PatientStateType,
      action: PayloadAction<any>
    ) => {
      state.addPatientPlan.isLoading = true;
      state.addPatientPlan.errors = "";
      state.addPatientPlan.data = null;
    },
    addPatientPlanSuccess: (
      state: patient.PatientStateType,
      action: PayloadAction<any>
    ) => {
      state.addPatientPlan.isLoading = false;
      state.addPatientPlan.data = action.payload;
      state.addPatientPlan.errors = null;
    },
    addPatientPlanError: (
      state: patient.PatientStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.addPatientPlan.isLoading = false;
      state.addPatientPlan.errors = error;
      state.addPatientPlan.data = null;
    },

    // get patient query list
    getPatientQueryListRequest: (
      state: patient.PatientStateType,
      action: PayloadAction<any>
    ) => {
      state.patientQueryList.isLoading = true;
      state.patientQueryList.errors = "";
      state.patientQueryList.data = null;
    },
    getPatientQueryListSuccess: (
      state: patient.PatientStateType,
      action: PayloadAction<any>
    ) => {
      state.patientQueryList.isLoading = false;
      state.patientQueryList.data = action.payload;
      state.patientQueryList.errors = null;
    },
    getPatientQueryListError: (
      state: patient.PatientStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.patientQueryList.isLoading = false;
      state.patientQueryList.errors = error;
      state.patientQueryList.data = null;
    },

    // send patient query
    sendPatientQueryRequest: (
      state: patient.PatientStateType,
      action: PayloadAction<any>
    ) => {
      state.patientSendQuery.isLoading = true;
      state.patientSendQuery.errors = "";
      state.patientSendQuery.data = null;
    },
    sendPatientQuerySuccess: (
      state: patient.PatientStateType,
      action: PayloadAction<any>
    ) => {
      state.patientSendQuery.isLoading = false;
      state.patientSendQuery.data = action.payload;
      state.patientSendQuery.errors = null;
    },
    sendPatientQueryError: (
      state: patient.PatientStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.patientSendQuery.isLoading = false;
      state.patientSendQuery.errors = error;
      state.patientSendQuery.data = null;
    },
  },
});

export const {
  // add Patient details
  addPatientRequest,
  addPatientSuccess,
  addPatientError,

  // get Patient list
  getPatientListRequest,
  getPatientListSuccess,
  getPatientListError,

  // delete Patient record
  deletePatientRecordRequest,
  deletePatientRecordSuccess,
  deletePatientRecordError,

  // add patient plan
  addPatientPlanRequest,
  addPatientPlanSuccess,
  addPatientPlanError,

  // get patient query list
  getPatientQueryListRequest,
  getPatientQueryListSuccess,
  getPatientQueryListError,

  // send patient query
  sendPatientQueryRequest,
  sendPatientQuerySuccess,
  sendPatientQueryError,
} = patientSlice.actions;
export default patientSlice.reducer;
